import { supportingDataApi } from '../../services/api';

export interface CompanyOption {
    value: number;
    label: string;
}

export const CASH_ENV_HIGH = 2;
export const CASH_ENV_LOW = 1;
// Same-day settlement, where the liquid ETF is itself spendable cash. Not a band
// between LOW and HIGH: it targets no cash buffer, so the scheme's tier rules are
// bypassed entirely. Global schemes run under this.
export const CASH_ENV_T0 = 3;
// Not a band either: each client's order is a fixed % — of AUM on a buy, of the ETF
// holding on a sell — sent alongside as aum_pct / holding_pct.
export const CASH_ENV_PERCENTAGE = 4;

export const CASH_ENV_OPTIONS = [
    { value: CASH_ENV_HIGH, label: 'High Cash Environment' },
    { value: CASH_ENV_LOW, label: 'Low Cash Environment' },
    { value: CASH_ENV_T0, label: 'T+0 Cash Environment' },
    { value: CASH_ENV_PERCENTAGE, label: 'Percentage' },
] as const;

export const loadEtfCompanyOptions = (onError?: (msg: string) => void) =>
    async (inputValue: string): Promise<CompanyOption[]> => {
        try {
            const { results } = await supportingDataApi.getEtfEligibleCompanies(inputValue, 1);
            return results.map(c => ({ value: c.id, label: `${c.name} (${c.symbol})` }));
        } catch {
            onError?.('Failed to load ETF companies');
            return [];
        }
    };
